import { orderColumns } from "../config/column";
import { getOrdersNowpayments } from "../api/respons";
import { useEffect, useState } from "react";
import TableCustom from "./TableCustom";

const OrdersNowpayments = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await getOrdersNowpayments();
        if (data.orders && data.orders.length > 0) {
          setOrders(data.orders);
        }
      } catch (error) {
        console.error("Ошибка при получении серверов:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (error) {
    return <div>Произошла ошибка: {error.message}</div>;
  }

  return (
    <div className="container mx-auto p-4 te">
      <h1 className="text-center py-5 text-3xl">Список ордеров Nowpayments</h1>
      <TableCustom items={orders} columns={orderColumns} />
    </div>
  );
};

export default OrdersNowpayments;
